<div class="min-h-dvh bg-gray-200">
  @if (calendarOptions | async; as options) {
    <app-calendar [options]="options" [dayOnly]="true"></app-calendar>
  }
  @switch (state | async) {
    @case ('closed') {
      <div class="w-full p-16 flex flex-row items-center justify-center">
        <p>{{ { key: 'facilityClosed', values: [{ date: (displayDate | async) || '', format: 'dd.LL.yyyy' } | luxon] } | i18n }}</p>
      </div>
    }
    @case ('blocked') {
      <div class="w-full p-16 flex flex-row items-center justify-center bg-">
        <p>{{ { key: 'facilityBlocked', values: [{ date: (displayDate | async) || '', format: 'dd.LL.yyyy' } | luxon] } | i18n }}</p>
      </div>
    }
  }
</div>
